import {CLEnumKeys, CLEnumsMapper} from 'common/src/modules/enums/enums.types';

export enum ProductStrategyTags {
  Feed = 'feed',
  DataSources = 'dataSources',
  TopItems = 'topItem',
  CategoryTopItems = 'categoryTopItem',
  ProductSet = 'productSet',
  ProductSetRequired = 'productSet:required',
  CategoryTopItemsRequired = 'categoryTopItem:required',
  HasPartialSuccess = 'hasPartialSuccess',
  IsConditionBased = 'isConditionBased',
}

const sportStrategies = [
  'SportsTeamUpcomingGame',
  'SportsTeamUpcomingGameExcludingLiveGames',
  'SportsTeamLastFinishedGame',
];

export default function getProductStrategyRelatedLogics(
  campaignEnumMapper: Record<string, CLEnumsMapper>,
  productsSelectionStrategy: number,
) {
  let tags: string[] = [];
  let name = '';

  if (campaignEnumMapper && productsSelectionStrategy) {
    const {tags: tagsValue, name: nameValue} =
      campaignEnumMapper[CLEnumKeys.CampaignPage.CampaignContentType].byValue[
        productsSelectionStrategy
      ];
    tags = tagsValue || [];
    name = nameValue;
  }

  const isFeedOriented = tags.includes(ProductStrategyTags.Feed);
  const isDataSourcesOriented = tags.includes(ProductStrategyTags.DataSources);
  const isTopItemsOriented = tags.includes(ProductStrategyTags.TopItems);
  const isCategoryTopItemsOriented = tags.includes(ProductStrategyTags.CategoryTopItems);
  const isRetargetingOriented = tags.includes(ProductStrategyTags.ProductSet);
  const isRetargetingProductSetRequired = tags.includes(ProductStrategyTags.ProductSetRequired);
  const isCategoryTopItemRequired = tags.includes(ProductStrategyTags.CategoryTopItemsRequired);
  const hasPartialSuccess = tags.includes(ProductStrategyTags.HasPartialSuccess);
  const isConditionBased = tags.includes(ProductStrategyTags.IsConditionBased);
  const isSportsStrategy = sportStrategies.includes(name);

  return {
    isFeedOriented,
    isDataSourcesOriented,
    isTopItemsOriented,
    isCategoryTopItemRequired,
    isRetargetingProductSetRequired,
    isRetargetingOriented,
    isCategoryTopItemsOriented,
    hasPartialSuccess,
    isConditionBased,
    isSportsStrategy,
  };
}
